import React from 'react';
import { FilterClassificationModel, filterClassificationModelInitial } from '../../../Models/FilterClassificationModel';
import { IInformationToCorrect } from './enum/InformationToCorrect';
import { SearchStatus } from '../../../shared/enum/SearchStatus';

export interface IRevisionContextProps {
    filterClassification: FilterClassificationModel,
    setFilterClassification: (filterClassification: FilterClassificationModel) => void,
    informationToCorrect: IInformationToCorrect | null,
    setInformationToCorrect: (info: IInformationToCorrect | null) => void,
    clientName: string,
    setClientName: (name: string) => void,
    ids: number[],
    setIds: (id: number[]) => void,
    spotlightBatchOpenDialog: boolean,
    setSpotlightBatchOpenDialog: (value: boolean) => void,
    contentBatchOpenDialog: boolean,
    setContentBatchOpenDialog: (value: boolean) => void,
    extraParametersBatchOpenDialog: boolean,
    setExtraParametersBatchOpenDialog: (value: boolean) => void
    sourceBatchOpenDialog: boolean,
    setSourceBatchOpenDialog: (value: boolean) => void,
    journalistBatchOpenDialog: boolean,
    setJournalistBatchOpenDialog: (value: boolean) => void
    keywordBatchOpenDialog: boolean,
    setKeywordBatchOpenDialog: (value: boolean) => void,
    coverPresenceBatchOpenDialog: boolean,
    setCoverPresenceBatchOpenDialog: (value: boolean) => void,
    locationBatchOpenDialog: boolean,
    setLocationBatchOpenDialog: (value: boolean) => void,
    vehicleBatchOpenDialog: boolean,
    setVehicleBatchOpenDialog: (value: boolean) => void,
    organogramBatchOpenDialog: boolean,
    setOrganogramBatchOpenDialog: (value: boolean) => void,
    expositionBatchOpenDialog: boolean,
    setExpositionBatchOpenDialog: (value: boolean) => void,
    searchStatus: SearchStatus,
    setSearchStatus: (value: SearchStatus) => void,
    mediaId: number,
    setMediaId: (id: number) => void,
}

export const revisionContextInitial: IRevisionContextProps = {
    filterClassification: {...filterClassificationModelInitial},
    setFilterClassification: () => { ''; },
    informationToCorrect: null,
    setInformationToCorrect: () => { ''; },
    clientName: '',
    setClientName: () => { ''; },
    ids: [],
    setIds: () => [],
    spotlightBatchOpenDialog: false,
    setSpotlightBatchOpenDialog: () => {'';},
    contentBatchOpenDialog: false,
    setContentBatchOpenDialog: () => {'';},
    extraParametersBatchOpenDialog: false,
    setExtraParametersBatchOpenDialog: () => {'';},
    sourceBatchOpenDialog: false,
    setSourceBatchOpenDialog: () => {'';},
    journalistBatchOpenDialog: false,
    setJournalistBatchOpenDialog: () => {'';},
    keywordBatchOpenDialog: false,
    setKeywordBatchOpenDialog: () => {'';},
    coverPresenceBatchOpenDialog: false,
    setCoverPresenceBatchOpenDialog: () => {'';},
    locationBatchOpenDialog: false,
    setLocationBatchOpenDialog: () => {'';},
    vehicleBatchOpenDialog: false,
    setVehicleBatchOpenDialog: () => {'';},
    organogramBatchOpenDialog: false,
    setOrganogramBatchOpenDialog: () => {'';},
    expositionBatchOpenDialog: false,
    setExpositionBatchOpenDialog: () => {'';},
    searchStatus: SearchStatus.INITIAL,
    setSearchStatus: () => { ''; },
    mediaId: 0,
    setMediaId: () => {'';},
};

export const RevisionContext = React.createContext(revisionContextInitial);